import React, { useEffect, useState } from 'react';

import { Box, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import AxlDialog from 'components/AxlDialog';
import { calculateNetTotal, updateHealthBenefitPaymentStatus } from 'repositories/HttpRepository';
import { HEALTH_BENEFITS_APPROVE_RATE } from 'constants/healthBenefits';

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function DialogApprove(props) {
  const { item, isOpen, onClose, getList } = props;
  const [rate, setRate] = useState(null);
  const [remark, setRemark] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [netTotal, setNetTotal] = useState(0.0);
  const [isCalculating, setIsCalculating] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setIsCalculating(true);
      const payload = {
        rate: rate || 0,
        remark: remark || '',
      };
      const res = await calculateNetTotal(item.id, payload);
      setNetTotal(res.data);
      setIsCalculating(false);
    }

    if (rate) {
      fetchData();
    }
  }, [rate]);

  const handleAgreeApprove = () => {
    if (isSubmitting || !item?.id) return;

    const params = {
      remark,
      rate,
    };

    setIsSubmitting(true);
    updateHealthBenefitPaymentStatus(item.id, 'APPROVED', params).then((res) => {
      setIsSubmitting(false);
      if (!res.ok) {
        toast.error(get(res, 'data.message') || 'Server is having problem, please try again later.', { autoClose: 2000 });
        return;
      }

      onClose();
      getList();
      toast.success('Approved successfully !', { autoClose: 2000 });
    });
  };

  const handleClose = () => {
    if (!isSubmitting) onClose();
  };

  return (
    <AxlDialog
      maxWidth="sm"
      isOpen={isOpen}
      childrenTitle={'Do you want to approve this request?'}
      handleClose={() => handleClose()}
      childrenAction={
        <Box sx={{ display: 'flex' }} style={{ gap: 8 }}>
          <Button disableElevation disabled={isSubmitting} onClick={() => handleClose()} color="inherit" variant="outlined" size="small">
            CANCEL
          </Button>
          <Button disableElevation disabled={!remark || !rate || isCalculating || error} onClick={() => handleAgreeApprove()} color="success" variant="contained" size="small">
            {isSubmitting ? <CircularProgress size={20} color="inherit" /> : 'APPROVE'}
          </Button>
        </Box>
      }
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            required
            autoFocus
            margin="dense"
            id="remark"
            name="remark"
            label="Type a message"
            fullWidth
            variant="outlined"
            minRows={3}
            multiline
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </Grid>
        <Grid size={12}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Select payment amount</InputLabel>
            <Select required value={rate} label="Select payment amount" onChange={(e) => setRate(e.target.value)}>
              {HEALTH_BENEFITS_APPROVE_RATE.map((item, idx) => (
                <MenuItem key={`${item.value}-${idx}`} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid sx={{ justifyContent: 'flex-end' }} size={12}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              fontWeight: 800,
              fontSize: 16,
            }}
          >
            Net Total: {isCalculating ? 'Calculating...' : `$${netTotal}`}
          </Box>
        </Grid>
      </Grid>
    </AxlDialog>
  );
}

export default DialogApprove;
